module.exports = __webpack_public_path__ + "img/feedly.png";